// Module generated from Markdown by Markdown Component Loader v1.1.0
import React from 'react';
import PropTypes from 'prop-types';

MarkdownComponent.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};

function MarkdownComponent(props) {
  const { className, style } = props;

  return (
    <div className={className} style={style}>
      <h2 id="deprecation-notice">Deprecation Notice</h2>
      <p>Consumers currently using the <code>https://api.va.gov/services/argonaut/v0</code> (and <code>https://dev-api.va.gov/services/argonaut/v0</code>) endpoint, please migrate your applications to use the new Veteran Health API (FHIR) endpoints: <code>https://api.va.gov/services/fhir/v0/argonaut/data-query/</code> and <code>https://dev-api.va.gov/services/fhir/v0/argonaut/data-query/</code>.</p>
      <p>Both the legacy API endpoints and this legacy documentation page will no longer be accessible beginning Oct 1, 2019.</p>
    </div>
  );
};

export default MarkdownComponent;
